"use client";

import { useRef } from "react";
import { usePortalTranslations } from "../i18n/client";
import styles from "./PortalSectionSearch.module.css";

export function PortalSectionSearch({ label, value, onChange, resultsId, loading = false }: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  resultsId: string;
  loading?: boolean;
}) {
  const t = usePortalTranslations();
  const inputRef = useRef<HTMLInputElement>(null);

  return <form className={styles.search} role="search" aria-label={label} data-loading={loading || undefined} onSubmit={(event) => event.preventDefault()}>
    <span className={styles.indicator} aria-hidden="true">
      <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 4 4" /></svg>
      <svg className={styles.spinner} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="8" opacity=".2" /><path d="M12 4a8 8 0 0 1 8 8" strokeLinecap="round" /></svg>
    </span>
    <span className={styles.status} role="status">{loading ? t("portal.search.loading") : ""}</span>
    <input ref={inputRef} type="search" aria-label={label} placeholder={t("portal.search.placeholder")} value={value} onChange={(event) => onChange(event.target.value)} aria-controls={resultsId} autoComplete="off" maxLength={200} />
    {value ? <button type="button" aria-label={t("portal.search.clear", {label})} onClick={() => { onChange(""); inputRef.current?.focus(); }}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" /></svg></button> : null}
  </form>;
}
